import React from 'react'

import { IconAlert } from '@avantstay/backoffice-vectors'

import { Button } from '../../components/Button'
import * as S from './ConfirmAction.styles'
import { ConfirmActionContentProps, ConfirmActionTheme } from './ConfirmAction.types'

const getMainButton = (theme: ConfirmActionTheme) => {
  if (theme === ConfirmActionTheme.danger) {
    return Button.Danger
  }
  return Button.Primary
}

// Keep this export clean, free of wrapping HOCs
function _ConfirmActionContent({
  title,
  message,
  onConfirm,
  onCancel,
  theme = ConfirmActionTheme.primary,
  cancelText = 'No',
  confirmText = 'Yes',
  confirmButtonType = 'button',
  formId,
  confirmButtonId,
  customVerticalAlignment,
  containerStyles = {},
  isConfirmLoading,
  isSubmitButtonDisabled,
}: ConfirmActionContentProps): JSX.Element {
  const MainButton = getMainButton(theme)
  return (
    <S.ConfirmActionContainer
      style={containerStyles}
      customVerticalAlignment={customVerticalAlignment}
    >
      <S.AlertContainer>
        {title && (
          <S.AlertHeader theme={theme}>
            <IconAlert />
            <S.AlertTitle data-testid="confirmation-action-title">{title}</S.AlertTitle>
          </S.AlertHeader>
        )}
        <S.AlertMessage data-testid="confirmation-action-messsage">{message}</S.AlertMessage>
        <S.AlertActions theme={theme}>
          <Button.Secondary
            onClick={onCancel}
            disabled={isConfirmLoading}
            data-testid="cancel-button-id"
          >
            {cancelText}
          </Button.Secondary>
          {confirmText && (
            <MainButton
              onClick={onConfirm}
              form={formId}
              id={confirmButtonId}
              data-testid="confirm-button-id"
              type={confirmButtonType}
              loading={isConfirmLoading}
              disabled={isSubmitButtonDisabled}
            >
              {confirmText}
            </MainButton>
          )}
        </S.AlertActions>
      </S.AlertContainer>
    </S.ConfirmActionContainer>
  )
}

// If you need to wrap this component with HOCs, use them here
const ConfirmActionContent = _ConfirmActionContent

export { ConfirmActionContent }
